import { ToBillArguments, ToBillEvent } from '../../../models/Factura';
import { PagoRequestPagoDoctoRel } from '../../../models/Pago';
import { ArgumentBinded } from './pago.state';

/**
 * Re-opens the payment event being edited and rebuilds the pago it stands for,
 * capped to whatever is still pending on the related bill.
 */
export function recoverPaymentToEdit(
    binded: ArgumentBinded[],
    billArgument: ToBillArguments<ToBillEvent>,
    paymentEvents: ToBillEvent[],
    eventid?: string) {

    const applicableBinder = binded.find(b => b.argument.uuid === billArgument.uuid);
    const applicableBinderIndex = binded.findIndex(b => b.argument.uuid === billArgument.uuid);

    const _applicablePaymentEvent = eventid ? (paymentEvents.find(pE => pE._id === eventid) || paymentEvents[0]) : paymentEvents[0];
    _applicablePaymentEvent.closedAt = null;
    _applicablePaymentEvent.isClosed = false;

    const _importePagadoIntended = _applicablePaymentEvent.paymentCFDI.pagos[0].monto;
    const _importePagadoMax = applicableBinder?.insoluto || 0;
    const relDocs: PagoRequestPagoDoctoRel[] = [{
        uuid: billArgument.uuid,
        importePagado: _importePagadoIntended > _importePagadoMax ? _importePagadoMax : _importePagadoIntended,
        numParcialidad: _applicablePaymentEvent.paymentNum
    }];

    // Editing gives back what the previous version of this payment had already covered
    if (eventid) {
        applicableBinder.insoluto += _applicablePaymentEvent.paymentCFDI.pagos[0].monto;
    }

    return {
        applicableBinder,
        argumentId: binded[applicableBinderIndex].argument._id,
        pago: {
            monto: relDocs[0].importePagado,
            facturaRelacionada: relDocs,
            formaDePago: _applicablePaymentEvent.paymentCFDI.pagos[0].formaDePago || '01'
        }
    }
}
